// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom"; 
// import config from '../../config';
// import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
// import { SortableContext, verticalListSortingStrategy, useSortable, arrayMove } from '@dnd-kit/sortable';
// import { CSS } from '@dnd-kit/utilities';

// // SortableItem component for drag and drop
// function SortableItem({ id, index, project, categoryMap }) {
//     const {
//         attributes,
//         listeners,
//         setNodeRef,
//         transform,
//         transition,
//         isDragging
//     } = useSortable({ id });

//     const style = {
//         transform: CSS.Transform.toString(transform),
//         transition,
//         opacity: isDragging ? 0.5 : 1,
//         zIndex: isDragging ? 1 : 0,
//     };

//     return (
//         <div 
//             ref={setNodeRef} 
//             style={style} 
//             className={`table-row ${isDragging ? 'dragging' : ''}`}
//         >
//             <div className="table-cell drag-handle" {...attributes} {...listeners}>
//                 <span className="drag-icon">⋮⋮</span>
//             </div>
//             <div className="table-cell priority-number">{index + 1}</div>
//             <div className="table-cell"><p>{project.title}</p></div>
//             <div className="table-cell"><p>{Array.isArray(project.category) && project.category.length > 0 ? project.category.map(c => categoryMap[c] || c).join(', ') : '-'}</p></div>
//             <div className="table-cell"><p>{project.ano}</p></div>
//             <div className="table-cell"><p>{project.cliente}</p></div>
//             <div className="table-cell text-right">
//                 <Link to={`/admin/project/${project._id}`} className="view_detail">View Details</Link>
//             </div>
//         </div>
//     );
// }

// function ProjectsListFeatured() {
//     const [projects, setProjects] = useState([]);
//     const [categoryMap, setCategoryMap] = useState({}); // id -> name
//     const [menus, setmenus] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
//     const navigate = useNavigate();

//     // Set up sensors for drag and drop
//     const sensors = useSensors(
//         useSensor(PointerSensor, {
//             activationConstraint: {
//                 distance: 5,
//             },
//         }),
//         useSensor(KeyboardSensor)
//     );

//     const fetchProjects = async () => {
//         try {
//             const response = await axios.get(`${config.BASE_URL}/api/admin/get-featured-projects-by-priority`, { withCredentials: true });

//             if(response.data){
//                 // Sort by priorityNumber (ascending) with null values at the end
//                 const sortedProjects = response.data.sort((a, b) => {
//                     const aPriority = typeof a.priorityNumber === 'number' ? a.priorityNumber : Infinity;
//                     const bPriority = typeof b.priorityNumber === 'number' ? b.priorityNumber : Infinity;
//                     return aPriority - bPriority;
//                 });

//                 // Auto-fill missing priority numbers without changing existing ones
//                 const used = new Set();
//                 sortedProjects.forEach(p => { if (typeof p.priorityNumber === 'number') used.add(p.priorityNumber); });
//                 let next = 1;
//                 const updates = [];
//                 sortedProjects.forEach(p => {
//                     if (typeof p.priorityNumber !== 'number') {
//                         while (used.has(next)) next += 1;
//                         updates.push({ _id: p._id, priorityNumber: next });
//                         used.add(next);
//                         next += 1;
//                     }
//                 });

//                 // Persist only newly assigned priorities
//                 // if (updates.length > 0) {
//                 //     try {
//                 //         await axios.post(`${config.BASE_URL}/api/admin/update-project-priorities`, { projects: updates }, { withCredentials: true });
//                 //         // Merge updates locally to reflect immediately
//                 //         const merged = sortedProjects.map(p => {
//                 //             const found = updates.find(u => u._id === p._id);
//                 //             return found ? { ...p, priorityNumber: found.priorityNumber } : p;
//                 //         });
//                 //         setProjects(merged);
//                 //     } catch (e) {
//                 //         setProjects(sortedProjects);
//                 //     }
//                 // } else {
//                     setProjects(sortedProjects);
//                 // }
//             }

//         } catch (err) {
//             setError('Failed to fetch featured projects');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchCategories = async () => {
//         try {
//             const res = await axios.get(`${config.BASE_URL}/api/admin/categories/list`, { withCredentials: true });
//             const list = res?.data?.data || [];
//             const map = {};
//             list.forEach(c => { if (c?._id) map[c._id] = c?.name; });
//             setCategoryMap(map);
//         } catch (e) {
//             // silent fail; will fallback to raw values
//         }
//     };

//     const handleDragEnd = async (result) => {
//         if (!result.destination) return;

//         const items = Array.from(projects);
//         const [moved] = items.splice(result.source.index, 1);
//         items.splice(result.destination.index, 0, moved);

//         // Update UI immediately
//         setProjects(items);

//         // Persist new priorities
//         try {
//             const payload = items.map((p, idx) => ({ _id: p._id, priorityNumber: idx + 1 }));
//             await axios.post(`${config.BASE_URL}/api/admin/update-project-priorities`, { projects: payload }, { withCredentials: true });
//         } catch (e) {
//             // fallback to server state
//             fetchProjects();
//         }
//     };

//     useEffect(() => {
//         fetchProjects();
//         fetchCategories();
//     }, []);

//     return (
//         <>
//             <div className="dashboard">
//                 <div className="container">
//                     <h1 className="dash_title">Featured Projects</h1>
//                     <div className="main-section">
//                         <div className="projects">
//                             <div className="projects-inner">
//                                 <header className="projects-header">
//                                     <div className="title">
//                                         Total 
//                                         <div className="count"> {projects.length } Featured Projects</div>
//                                     </div>
//                                     <div className="project_search">
//                                         <form action="">
//                                             <input type="text" name="search" placeholder="Search featured projects" />
//                                             <button type="submit" className="btn">Search</button>
//                                         </form>
//                                     </div>
//                                     <div className="add_project">
//                                     <Link to="/admin/add-project">Add Project</Link>
//                                     </div>
//                                 </header>
//                                 <DragDropContext onDragEnd={handleDragEnd}>
//                                     <Droppable droppableId="featured-projects">
//                                         {(provided, snapshot) => (
//                                             <div
//                                                 {...provided.droppableProps}
//                                                 ref={provided.innerRef}
//                                                 className={`projects-table ${snapshot.isDraggingOver ? 'dragging-over' : ''}`}
//                                             >
//                                                 <div className="table-header">
//                                                     <div className="header-cell drag-handle">Drag</div>
//                                                     <div className="header-cell">Priority</div>
//                                                     <div className="header-cell">Project Title</div>
//                                                     <div className="header-cell">Categories</div>
//                                                     <div className="header-cell">Ano</div>
//                                                     <div className="header-cell">Cliente</div>
//                                                     <div className="header-cell text-right">Actions</div>
//                                                 </div>
//                                                 <div className="table-body">
//                                                     {loading ? (
//                                                         <div className="table-row">
//                                                             <div className="table-cell">Loading...</div>
//                                                         </div>
//                                                     ) : error ? (
//                                                         <div className="table-row">
//                                                             <div className="table-cell">{error}</div>
//                                                         </div>
//                                                     ) : (
//                                                         projects.map((project, index) => (
//                                                             <Draggable key={`${project._id}`} draggableId={`${project._id}`} index={index}>
//                                                                 {(providedRow, snapshotRow) => (
//                                                                     <div
//                                                                         ref={providedRow.innerRef}
//                                                                         {...providedRow.draggableProps}
//                                                                         className={`table-row ${snapshotRow.isDragging ? 'dragging' : ''}`}
//                                                                     >
//                                                                         <div className="table-cell drag-handle" {...providedRow.dragHandleProps}>
//                                                                             <span className="drag-icon">⋮⋮</span>
//                                                                         </div>
//                                                                         <div className="table-cell priority-number">{index + 1}</div>
//                                                                         <div className="table-cell"><p>{project.title}</p></div>
//                                                                         <div className="table-cell"><p>{Array.isArray(project.category) && project.category.length > 0 ? project.category.map(c => categoryMap[c] || c).join(', ') : '-'}</p></div>
//                                                                         <div className="table-cell"><p>{project.ano}</p></div>
//                                                                         <div className="table-cell"><p>{project.cliente}</p></div>
//                                                                         <div className="table-cell text-right">
//                                                                             <Link to={`/admin/project/${project._id}`} className="view_detail">View Details</Link>
//                                                                         </div>
//                                                                     </div>
//                                                                 )}
//                                                             </Draggable>
//                                                         ))
//                                                     )}
//                                                     {provided.placeholder}
//                                                 </div>
//                                             </div>
//                                         )}
//                                     </Droppable>
//                                 </DragDropContext>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default ProjectsListFeatured;










import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
    DragEndEvent,
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import config from '../../config';
function SortableProjectRow({ project, index, categoryMap }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: project._id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.8 : 1,
        background: isDragging ? '#f0f8ff' : 'transparent',
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            className={`table-row ${isDragging ? 'dragging' : ''}`}
        >
            <div className="table-cell drag-handle" {...listeners}>
                <span className="drag-icon">Drag</span>
            </div>

            <div className="table-cell priority-number">{index + 1}</div>
            <div className="table-cell"><p>{project.title}</p></div>
            <div className="table-cell">
                <p>
                    {Array.isArray(project.category) && project.category.length > 0
                        ? project.category.map(c => categoryMap[c] || c).join(', ')
                        : '-'}
                </p>
            </div>
            <div className="table-cell"><p>{project.ano}</p></div>
            <div className="table-cell"><p>{project.cliente}</p></div>
            <div className="table-cell text-right">
                <Link to={`/admin/project/${project._id}`} className="view_detail">
                    View Details
                </Link>
            </div>
        </div>
    );
}
function ProjectsListFeatured() {
    const [projects, setProjects] = useState([]);
    const [categoryMap, setCategoryMap] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8,
            },
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );
    const fetchProjects = async () => {
        try {
            const response = await axios.get(
                `${config.BASE_URL}/api/admin/get-featured-projects-by-priority`,
                { withCredentials: true }
            );

            if (response.data) {
                let sortedProjects = response.data.sort((a, b) => {
                    const aPriority = typeof a.priorityNumber === 'number' ? a.priorityNumber : Infinity;
                    const bPriority = typeof b.priorityNumber === 'number' ? b.priorityNumber : Infinity;
                    return aPriority - bPriority;
                });
                const used = new Set();
                sortedProjects.forEach((p) => {
                    if (typeof p.priorityNumber === 'number') used.add(p.priorityNumber);
                });

                let next = 1;
                const updates = [];
                sortedProjects = sortedProjects.map((p) => {
                    if (typeof p.priorityNumber !== 'number') {
                        while (used.has(next)) next++;
                        updates.push({ _id: p._id, priorityNumber: next });
                        used.add(next);
                        next++;
                        return { ...p, priorityNumber: next - 1 };
                    }
                    return p;
                });

                setProjects(sortedProjects);

            }
        } catch (err) {
            setError('Failed to fetch featured projects');
        } finally {
            setLoading(false);
        }
    };

    const fetchCategories = async () => {
        try {
            const res = await axios.get(`${config.BASE_URL}/api/admin/categories/list`, {
                withCredentials: true,
            });
            const list = res?.data?.data || [];
            const map = {};
            list.forEach((c) => {
                if (c?._id) map[c._id] = c?.name;
            });
            setCategoryMap(map);
        } catch (e) {
            // Silent fail
        }
    };
    const handleDragEnd = async (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        const oldIndex = projects.findIndex(p => p._id === active.id);
        const newIndex = projects.findIndex(p => p._id === over.id);

        const newOrder = arrayMove(projects, oldIndex, newIndex);
        const payload = newOrder.map((p, idx) => ({
            _id: p._id,
            priorityNumber: idx + 1,
        }));

        setProjects(newOrder);

        try {
            await axios.post(
                `${config.BASE_URL}/api/admin/update-project-priorities`,
                { projects: payload },
                { withCredentials: true }
            );
        } catch (e) {
            fetchProjects();
        }
    };
    useEffect(() => {
        fetchProjects();
        fetchCategories();
    }, []);
    return (
        <>
            <div className="dashboard">
                <div className="container">
                    <h1 className="dash_title">Featured Projects</h1>
                    <div className="main-section">
                        <div className="projects">
                            <div className="projects-inner">
                                <header className="projects-header">
                                    <div className="title">
                                        Total
                                        <div className="count"> {projects.length} Featured Projects</div>
                                    </div>
                                    <div className="project_search">
                                        <form action="">
                                            <input
                                                type="text"
                                                name="search"
                                                placeholder="Search featured projects"
                                            />
                                            <button type="submit" className="btn">Search</button>
                                        </form>
                                    </div>
                                    <div className="add_project">
                                        <Link to="/admin/add-project">Add Project</Link>
                                    </div>
                                </header>

                                <DndContext
                                    sensors={sensors}
                                    collisionDetection={closestCenter}
                                    onDragEnd={handleDragEnd}
                                >
                                    <SortableContext
                                        items={projects.map(p => p._id)}
                                        strategy={verticalListSortingStrategy}
                                    >
                                        <div className="projects-table">
                                            <div className="table-header">
                                                <div className="header-cell drag-handle">Drag</div>
                                                <div className="header-cell">Priority</div>
                                                <div className="header-cell">Project Title</div>
                                                <div className="header-cell">Categories</div>
                                                <div className="header-cell">Ano</div>
                                                <div className="header-cell">Cliente</div>
                                                <div className="header-cell text-right">Actions</div>
                                            </div>

                                            <div className="table-body">
                                                {loading ? (
                                                    <div className="table-row">
                                                        <div className="table-cell">Loading...</div>
                                                    </div>
                                                ) : error ? (
                                                    <div className="table-row">
                                                        <div className="table-cell">{error}</div>
                                                    </div>
                                                ) : projects.length === 0 ? (
                                                    <div className="table-row">
                                                        <div className="table-cell">No featured projects</div>
                                                    </div>
                                                ) : (
                                                    projects.map((project, index) => (
                                                        <SortableProjectRow
                                                            key={project._id}
                                                            project={project}
                                                            index={index}
                                                            categoryMap={categoryMap}
                                                        />
                                                    ))
                                                )}
                                            </div>
                                        </div>
                                    </SortableContext>
                                </DndContext>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ProjectsListFeatured;
